import React from 'react';
import { FormikErrors, FormikTouched } from 'formik';

import { Fields, PropertyNames } from '../Types';

import './Checkbox.scss';

interface Props<T extends Fields> {
    checked?: boolean;
    children?: React.ReactNode;
    disabled?: boolean;
    errors: FormikErrors<T>;
    infoText?: string;
    infoTitle?: string;
    label?: string;
    name: PropertyNames<T, boolean>;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    required?: boolean;
    touched: FormikTouched<T>;
    value: string;
}

const Checkbox = <T extends Fields>(props: Props<T>) => {
    const className = 'fancy-checkbox';
    const inputId = `${className}-${props.name}-${props.value}`;

    if (!props.label && !props.children) {
        throw new Error('Either label or children are required');
    }

    return (
        <div className={className}>
            <input
                checked={props.checked}
                className={`${className}__input`}
                disabled={props.disabled}
                id={inputId}
                name={props.name}
                onChange={props.onChange}
                required={props.required}
                type="checkbox"
                value={props.value}
            />

            <label htmlFor={inputId}>
                <i className={`${className}__i`} />
                <span>{props.label || props.children}</span>
            </label>

            <div className="error">{props.touched[props.name] && props.errors[props.name]}</div>
        </div>
    );
};

export default Checkbox;
